/*global FormController, WebView*/


var userPrefsController = new FormController("res_users", 
    {
        directory: "views/user",
        name: "userPrefsPopup",
        route: "user-prefs",
        buttonsHTML: "<!-- no button -->",
        openInPopup: true,
        noTitle: true,
        defaultData: {
            state: "manual"
        },
        popup: {
            noHeader: true,
            size: "medium"
        },
        
    }
);


userPrefsController.prepareDataOnEnter = function(data, callback) {
    var refreshValues = this.view.refreshValues?this.view.refreshValues.bind(this.view):function(cb){ cb() ;} ;
    refreshValues(function(err){
        if(err){ return callback(err); }
        this.api.db.res_users.searchFirst({id: this.api.currentUser.id}, [
            { otherTable: "res_partner", name: "partner" },
            { otherTable: "iz_user_group_res_users_rel", name: "linkGroups", type:"2many", joins: [
                { otherTable: "iz_notification_custom_iz_user_group_rel", name: "notifCustom", type:"2many", 
                    thisField: "iz_user_group_id", otherField: "iz_user_group_id", joins: [
                        { otherTable: "iz_notification_custom", name: "notifCustom" }
                 ] },
            ] },
            { otherTable: "iz_oauth_token", type: "2many", name: "tokens", thisField: "id", otherField: "user_id"},
            { otherTable: "iz_user_notif_settings", type: "2many", name: "notifSettings", thisField: "id", otherField: "user_id" },
            { otherTable: "ir_attachment", readOnly: true, type: "2one", name: "attach", thisField: "id", otherField: "res_id", 
                        joinSearch: {res_model: "res.users", name: "signature"}}
        ], function(err, user){
            if(err){ return callback(err) ;}

            var activatedQuicks =(user.iz_menu_quick||"").split(",") ;
            var menuQuicks = [] ;
            var notifTypes = ["message"] ;
            window.IZEE_MODULES.forEach(function(module){
                var menuQuick = module.menuQuick ;
                if(menuQuick){
                    if(!Array.isArray(menuQuick)){
                        menuQuick = [menuQuick] ;
                    }
                    menuQuick = menuQuick.filter(function(e){
                        if(!e.rights){ return true ;}
                        var rights = e.rights.split(/\s/).map(function(w){
                            if(w === "&&" || w === "||" || w === "(" || w === ")"){ return w ;}
                            return "user.rights."+w ;
                        }).join(" ") ;
                        return new Function("user", "return "+rights)(this.api.currentUser||{rights:{}}) ;
                    }.bind(this));
                    menuQuick.forEach(function(m){
                        menuQuicks.push({
                            id : m.id,
                            label: m.label,
                            active: (activatedQuicks.indexOf(m.id) !== -1)
                        }) ;
                    }) ;
                }
                if(module.notifications){
                    module.notifications.forEach(function(n){
                        notifTypes.push(n) ;
                    });
                }
            }.bind(this)) ;

            user.linkGroups.forEach(function(linkGroup){
                linkGroup.notifCustom.forEach(function(notifCustom){
                    if(notifCustom.notifCustom.active){
                        notifTypes.push({code: notifCustom.notifCustom.code, label: notifCustom.notifCustom.label}) ;
                    }
                });
            });

            var notifs = [] ;
            notifTypes.forEach(function(type){
                var freq = null;
                var hour = null;
                var n = type ;
                if(type.code){
                    n = type.code;
                }
                user.notifSettings.some(function(f){
                    if(f.notification_type === n){
                        freq = f.frequency ;
                        hour = f.hour ;
                        return true ;
                    }
                }) ;
                notifs.push({
                    type: n,
                    label: type.label || WebView.tr("notification."+n),
                    frequency: freq || "hour",
                    hour: hour
                });
            }) ;

            user.menuQuicks = menuQuicks ;
            user.notifs = notifs ;
            user.lang = user.partner.lang ;
            user.mobile = user.partner.mobile ;
            user.openData = data ;

            this.mode = "modify" ;
            this.currentRecord = user ;
            if(user.attach){
                var extension = "";
                if(user.attach.datas_fname && user.attach.datas_fname.indexOf(".") !== -1){
                    extension = user.attach.datas_fname.substring(user.attach.datas_fname.lastIndexOf(".")) ;
                }
                var filename = "signature"+extension;
                this.api.readBinary.url(user.attach, filename, function(err, url){
                    if(err){ 
                        console.log("Can't get image") ;
                    }else{
                        user.signatureUrl = url ;
                    }
                    return userPrefsController.prepareRecord(user, callback) ;
                }) ;
            }else{
                return userPrefsController.prepareRecord(user, callback) ;
            }
        }.bind(this)) ;
    }.bind(this)) ;
} ;

userPrefsController.prepareRecord = function(data, callback){
    var searches = {
        delegations: { 
            table: "iz_user_replace",
            search: {
                date_end : { ope: ">=", value: new Date() },
                user_id: this.api.currentUser.id
            }
        }
    };
    this.api.db.multiread(searches, function(err, reads){
        if(err){ return callback(err) ;}
        if (reads.delegations) {
            data.delegations = reads.delegations;
        }
        callback(null, data);
    }.bind(this));
};


userPrefsController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
} ;
userPrefsController.onCancel = function(){
    this.view.close() ;
} ;

userPrefsController.onValidate = function(){
    this.view.longTask(function(done){
        this.doValidate(function(err, savedRecord){
            if(err){ return done(err); }
            if(!savedRecord){
                //check failed
                return done() ;
            }
            this.api.auth.refreshUser(function(err, user){
                if(err){ return done(err); }
                if(user.lang){
                    var lang = user.lang.replace("_", "-") ;
                    if(lang !== WebView.i18n.getLang()){
                        window.location.reload() ;//force reload on lang change
                    }
                }
                this.appController.emit("userPrefSaved") ;
                this.mode = 'read' ; //avoid abort input warning
                this.view.close() ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

userPrefsController.computeErrorText = async function(errorIds) {
    let names = await this.apip.db.multiread({
        users : {
            table: "res_users",
            search: {id: {"ope": "in", value:errorIds}},
            joinFetch: [
                { otherTable: "res_partner", name: "partner", thisField: "partner_id", otherField: "id" }
            ]
        } 
    });

    names = names.users.map(user => user.partner.name);
    let str = names.reduce((acc, name, index) => {
        if (index === 0) { // No separator for the first name
            return name;
        }
        if (index === names.length - 1) { // Use "and" (or "et" in french) separator for the last name
            return acc + WebView.tr("userPrefs.nameSeparator") + name;
        }
        return acc + ", " + name; // Use normal separator
    }, "");

    return str;
};

userPrefsController.validations.push(async function check(params, callback){

    if (params.data.delegations && params.data.delegations.length > 0) {
        let delegationSubstitutesIds = [];
        // Dates controls
        for (let delegation of params.data.delegations) {
            if (!delegation.user_replace_id || !delegation.date_start || !delegation.date_end) { return callback();};
            delegationSubstitutesIds.push(delegation.user_replace_id);
            let startDate = new Date(delegation.date_start);
            let endDate = new Date(delegation.date_end);
            // control date start < date end
            if (startDate > endDate) {
                return callback(null, WebView.tr("userPrefs.startDateAfterEndDate"));
            }

            // control that a new delegation doesn't start before today
            let readsDelegations = await this.apip.db.multiread({
                existing : {
                    table: "iz_user_replace",
                    search: {
                        user_id: delegation.user_id,
                        user_replace_id : delegation.user_replace_id,
                        date_start: delegation.date_start,
                        date_end: delegation.date_end
                    },
                    joinFetch: [
                        { otherTable: "res_users", name: "sub", thisField: "user_replace_id", otherField: "id" , joins : [
                            { otherTable: "res_partner", thisField: "partner_id", otherField: "id" }
                        ]},
                        { otherTable: "res_users", name: "del", thisField: "user_id", otherField: "id" , joins : [
                            { otherTable: "res_partner", thisField: "partner_id", otherField: "id" }
                        ]},
                    ]
                },
                delegations : {
                    table: "iz_user_replace",
                    search: {
                        user_id: delegation.user_replace_id
                    }, 
                    joinFetch: [
                        { otherTable: "res_users", name: "sub", thisField: "user_replace_id", otherField: "id" , joins : [
                            { otherTable: "res_partner", thisField: "partner_id", otherField: "id" }
                        ]},
                        { otherTable: "res_users", name: "del", thisField: "user_id", otherField: "id" , joins : [
                            { otherTable: "res_partner", thisField: "partner_id", otherField: "id" }
                        ]},
                    ]
                }
            });  
            let existingDelegation = false;
            if (readsDelegations && readsDelegations.existing) {
                existingDelegation = readsDelegations.existing.some(exist => {
                    return exist.user_id === delegation.user_id && 
                    exist.user_replace_id === delegation.user_replace_id && 
                    new Date(exist.date_start).getTime() === new Date(delegation.date_start).getTime() &&
                    new Date(exist.date_end).getTime() === new Date(delegation.date_end).getTime();
                });
            }
            if (!existingDelegation) { // don't control the start date for existing delegation
                let today = new Date();
                today.setHours(0, 0, 0, 0);
                if (startDate < today) {
                    return callback(null, WebView.tr("userPrefs.startDateBeforeToday"));
                }
            }
            // dates overlap control
            if (readsDelegations && readsDelegations.delegations) {
                readsDelegations.delegations.forEach(delegationCheckOverlap=>{
                    if (/*delegation.user_id === this.api.currentUser.id && */delegationCheckOverlap.user_id === delegation.user_replace_id) {
                        let delegatorStartDate = new Date(delegationCheckOverlap.date_start);
                        let delegatorEndDate = new Date(delegationCheckOverlap.date_end);
                        if ((startDate >= delegatorStartDate && startDate <= delegatorEndDate) || (endDate >= delegatorStartDate && endDate <= delegatorEndDate) || (endDate >= delegatorEndDate && startDate <= delegatorStartDate)) {
                            return callback(null, WebView.tr("userPrefs.delegationOverlap", {delegator: delegationCheckOverlap.del.res_partner.name, substitute: delegationCheckOverlap.sub.res_partner.name}));
                        }
                    }
                });
            }
        }

        // Group delegations by user_replace_id
        const groupedDelegations = params.data.delegations.reduce((acc, delegation) => {
            if (!acc[delegation.user_replace_id]) {
                acc[delegation.user_replace_id] = [];
            }
            acc[delegation.user_replace_id].push(delegation);
            return acc;
        }, {});

        // Check for overlaps within each group
        for (const userReplaceId in groupedDelegations) {
            const userDelegations = groupedDelegations[userReplaceId];

            // Sort delegations by date_start
            userDelegations.sort((a, b) => new Date(a.date_start) - new Date(b.date_start));

            // Check for overlaps
            for (let i = 1; i < userDelegations.length; i++) {
                const prevDelegation = userDelegations[i - 1];
                const currentDelegation = userDelegations[i];

                // Check if the current delegation starts before or the same day the previous one ends
                if ((new Date(currentDelegation.date_start) <= new Date(prevDelegation.date_end)) && (currentDelegation.id !== prevDelegation.id)) {
                    return callback(null, WebView.tr("userPrefs.subOverlap"));
                }
            }
        }
        
        // User rights controls
        if (delegationSubstitutesIds.length > 0) {
            var searches = {
                rightsUser: { 
                    table: "res_groups_users_rel",
                    search: {
                        uid: this.api.currentUser.id
                    }
                },
                rightsSubstitute: { 
                    table: "res_groups_users_rel",
                    search: {
                        uid: delegationSubstitutesIds
                    }
                },
                spacesRestrictions: {
                    table: "iz_doc_space",
                    search: { active: true },
                    joinFetch: [
                        { otherTable: "iz_doc_space_iz_user_group_rel",
                            type: "2many",
                            name: "groupsSpacesRestrictions",
                            thisField: "id",
                            otherField: "iz_doc_space_id",
                            joins: [
                                { otherTable: "iz_user_group_res_users_rel", type: "2many", name: "usersSpacesRestrictions", otherField: "iz_user_group_id", thisField: "iz_user_group_id"}
                            ]
                        }
                    ]
                },
                workflowsRestrictions: {
                    table: "iz_doc_workflow",
                    search: { active: true },
                    joinFetch: [
                        { otherTable: "iz_doc_workflow_iz_user_group_rel",
                            type: "2many",
                            name: "groupsWorkflowsRestrictions",
                            thisField: "id",
                            otherField: "iz_doc_workflow_id",
                            joins: [
                                { otherTable: "iz_user_group_res_users_rel", type: "2many", name: "usersWorkflowsRestrictions", otherField: "iz_user_group_id", thisField: "iz_user_group_id"}
                            ]
                        }
                    ]
                }
            };
            this.api.db.multiread(searches, async function(err, reads){
                if(err){ return callback(err) ;}

                // Check that the replacing user has the same rights as the original user
                if (reads.rightsUser && reads.rightsUser.length > 0 && reads.rightsSubstitute && reads.rightsSubstitute.length > 0) {
                    for (let rightUser of reads.rightsUser) {
                        let matchingSubstitute = false;
                        delegationSubstitutesIds.forEach(substituteId => {
                            let substituteGidArray = reads.rightsSubstitute.filter(uid => uid.uid === substituteId );
                            if (substituteGidArray.length >0 ) {
                                matchingSubstitute = substituteGidArray.some(rightSubstitute => 
                                    rightSubstitute.gid === rightUser.gid
                                );
                            } 
                        });

                        if (!matchingSubstitute) {
                            let str = await this.computeErrorText(delegationSubstitutesIds);
                            if(delegationSubstitutesIds.length === 1) { 
                                return callback(null, WebView.tr("userPrefs.substituteRightsMissing", {user: str}));
                            } else { // more than 1
                                return callback(null, WebView.tr("userPrefs.severalSubstituteRightsMissing", {users: str}));
                            }
                        }
                    }

                    let groupSpacesRightsMissing = false;
                    // Space rights controls
                    if (reads.spacesRestrictions && reads.spacesRestrictions.length > 0) { 
                        reads.spacesRestrictions.forEach(spaceRestriction=>  { // the accesses of each space are checked
                            let delegateeHasSpacesPermissions = false;
                            let delegatorsSpacesPermissionsArray = [];
                            if (spaceRestriction.groupsSpacesRestrictions && spaceRestriction.groupsSpacesRestrictions.length > 0) { // there is restriction(s) on the space
                                delegationSubstitutesIds.forEach(id=>{
                                    for (let group of spaceRestriction.groupsSpacesRestrictions) { // Each group with this space access is checked
                                        if (group.usersSpacesRestrictions && group.usersSpacesRestrictions.length > 0) { // each user must have an access to the space with any group
                                            if (group.usersSpacesRestrictions.some(user=> user.res_users_id === this.api.currentUser.id)) {
                                                delegateeHasSpacesPermissions = true; // delegatee access allowed : so the access of the delegators of this space must be checked;
                                            };
                                            if (group.usersSpacesRestrictions.some(user=> user.res_users_id === id)) {
                                                delegatorsSpacesPermissionsArray.push(id); // the delegator has access to this space                               
                                            }
                                        }
                                    }
                                });
                            }
                            const everyDelegatorHasAccess = delegationSubstitutesIds.every(id => delegatorsSpacesPermissionsArray.includes(id));
                            if (delegateeHasSpacesPermissions && !everyDelegatorHasAccess) {
                                groupSpacesRightsMissing = true;
                            }
                        });
                    } // case else : there is no restriction on any space

                    // Mechanism to avoid multiple error message
                    if(groupSpacesRightsMissing) {
                        return callback(null, WebView.tr("userPrefs.groupSpacesRightsMissing"));
                    }

                    let groupWorkflowsRightsMissing = false;
                    // workflows rights controls
                    if (reads.workflowsRestrictions && reads.workflowsRestrictions.length > 0) { 
                        reads.workflowsRestrictions.forEach(workflowRestriction=>  { // the accesses of each workflow are checked
                            let delegateeHasWorkflowsPermissions = false;
                            let delegatorsWorkflowsPermissionsArray = [];
                            if (workflowRestriction.groupsWorkflowsRestrictions && workflowRestriction.groupsWorkflowsRestrictions.length > 0) { // there is restriction(s) on the workflow
                                delegationSubstitutesIds.forEach(id=>{
                                    for (let group of workflowRestriction.groupsWorkflowsRestrictions) { // Each group with this workflow access is checked
                                        if (group.usersWorkflowsRestrictions && group.usersWorkflowsRestrictions.length > 0) { // each user must have an access to the workflow with any group
                                            if (group.usersWorkflowsRestrictions.some(user=> user.res_users_id === this.api.currentUser.id)) {
                                                delegateeHasWorkflowsPermissions = true; // delegatee access allowed : so the access of the delegators of this workflow must be checked;
                                            };
                                            if (group.usersWorkflowsRestrictions.some(user=> user.res_users_id === id)) {
                                                delegatorsWorkflowsPermissionsArray.push(id); // the delegator has access to this workflow                               
                                            }
                                        }
                                    }
                                });
                            }
                            const everyDelegatorHasAccess = delegationSubstitutesIds.every(id => delegatorsWorkflowsPermissionsArray.includes(id));
                            if (delegateeHasWorkflowsPermissions && !everyDelegatorHasAccess) {
                                groupWorkflowsRightsMissing = true;
                            }
                        });
                    } // case else : there is no restriction on any workflow

                    // Mechanism to avoid multiple error message
                    if(groupWorkflowsRightsMissing) {
                        return callback(null, WebView.tr("userPrefs.groupWorkflowsRightsMissing"));
                    }

                } else {
                    let str = await this.computeErrorText(delegationSubstitutesIds);
                    if(delegationSubstitutesIds.length === 1) { 
                        return callback(null, WebView.tr("userPrefs.substituteRightsMissing", {user: str}));
                    } else { // more than 1
                        return callback(null, WebView.tr("userPrefs.severalSubstituteRightsMissing", {users: str}));
                    }
                }
                callback() ;
            }.bind(this));
        }   
    } else {
        callback();
    }
}.bind(userPrefsController));

userPrefsController.getRecordsToSave = function(viewData, dataBeforeModif, callback){

    var records = [] ;
    records.push({
        table: "res_partner",
        action: "update",
        record: {
            id: this.data.partner.id,
            lang: viewData.lang,
            mobile: viewData.mobile
        }
    }) ;

    var strMenu = viewData.menuQuicks.filter(function(m){
        return m.active;
    }).map(function(m){
        return m.id ;
    }).join(",") ;

    records.push({
        table: "res_users",
        action: "update",
        record: {
            id: this.data.id,
            iz_menu_quick: strMenu,
            iz_mail_signature: this.data.iz_mail_signature
        }
    }) ;

    viewData.notifs.forEach(function(n){
        records.push({
            table: "iz_user_notif_settings",
            action: "insertOrUpdate",
            conditions: {
                user_id: this.api.currentUser.id,
                notification_type: n.type
            },
            record: {
                user_id: this.api.currentUser.id,
                notification_type: n.type,
                frequency: n.frequency,
                hour: n.hour
            }
        }) ;
    }.bind(this)) ;

    dataBeforeModif.delegations.forEach(function(oldDelegation){
        if (viewData.delegations && viewData.delegations.length > 0) {
            const oldDelegationUnchanged = viewData.delegations.find(newDelegation=> newDelegation.user_id === oldDelegation.user_id && newDelegation.user_replace_id === oldDelegation.user_replace_id && newDelegation.date_start === oldDelegation.date_start && newDelegation.date_end === oldDelegation.date_end);
            if (!oldDelegationUnchanged) {
                records.push({
                    table: "iz_user_replace",
                    action: "remove",
                    record: {
                        id: oldDelegation.id
                    }
                }) ;
            }
        } else {
            records.push({
                table: "iz_user_replace",
                action: "remove",
                record: {
                    id: oldDelegation.id
                }
            }) ;
        }
    }.bind(this)) ;

    viewData.delegations.forEach(function(newDelegation){
        const newDelegationUnchanged = dataBeforeModif.delegations.find(oldDelegation=> oldDelegation.user_id === newDelegation.user_id && oldDelegation.user_replace_id === newDelegation.user_replace_id && oldDelegation.date_start === newDelegation.date_start && oldDelegation.date_end === newDelegation.date_end);
        if (!newDelegationUnchanged) {
            records.push({
                table: "iz_user_replace",
                action: "insert",
                conditions: {
                    user_id: this.api.currentUser.id
                },
                record: {
                    user_id: this.api.currentUser.id,
                    user_replace_id: newDelegation.user_replace_id,
                    date_start: newDelegation.date_start,
                    date_end: newDelegation.date_end
                }
            }) ;
        }
    }.bind(this)) ;
    callback(null, records) ;
};

userPrefsController.onUnsyncOffice365 = function(){
    this.view.longTask(function(done){
        this.api.db.transactionalChanges([
            {
                table: "res_users",
                action: "update",
                record: {
                    id: this.data.id,
                    iz_token_office365: null
                }
            }
        ], function(err){
            if(err){ return done(err) ;}
            this.enter() ;
            done() ;
        }.bind(this));
    }.bind(this));
};

userPrefsController.onSyncOffice365 = function(){
    this.view.longTask(function(done){
        this.api.office365.getAuthUrl(this.data.id, window.location.href, function(err, authUrl){
            if(err){ return done(err) ;}
            window.location.href = authUrl ;
            done() ;
        }) ;
    }.bind(this)) ;
};

userPrefsController.onUploadSignature = function(){
    WebView.upload({
        multiple: false, 
        accept: ".jpg,.png",
        sizeLimit: 999000
    },function(file){
        if(!file){ return ;}
        this.data.file = file ;
        this.view.longTask(function(done){

            var binaryRecord = {
                res_model: "res.users", 
                res_id: this.data.id, 
                mimetype: file.type,
                datas_fname : file.name,
                name: "signature",
                res_name: this.data.name
            };
            if(this.data.attach){
                binaryRecord.id = this.data.attach.id ;
            }

            this.api.api.saveBinary(
                file,
                binaryRecord, function(err, binary){
                if(err){ return done(err) ;}
                this.refresh() ;
                done() ;
            }.bind(this)) ;
            
        }.bind(this)) ;
    }.bind(this));
} ;

module.exports = userPrefsController ;
